'use client';

import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error no manejado:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-8 h-8 text-red-400" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">Algo salió mal</h2>
        <p className="text-slate-400 mb-6">
          Ocurrió un error inesperado. Por favor intenta de nuevo.
        </p>
        {error.digest && (
          <p className="text-xs text-slate-600 mb-4 font-mono">
            Referencia: {error.digest}
          </p>
        )}
        <div className="flex gap-3 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-gradient-to-r from-[#E31B23] to-[#FF4500] text-white font-semibold rounded-lg hover:from-[#FF2D35] hover:to-[#FF6B35] transition"
          >
            Intentar de nuevo
          </button>
          <a
            href="/"
            className="px-6 py-3 border border-slate-700 text-slate-300 rounded-lg hover:bg-slate-800 transition"
          >
            Ir al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
